import React from 'react';

import { formatMoney } from '../../../utils/formatMoney';
import type { DashboardPipelinePhase } from '../types';

type DashboardPipelineRowProps = {
  phase: DashboardPipelinePhase;
  maxCount: number;
};

export function DashboardPipelineRow({ phase, maxCount }: DashboardPipelineRowProps) {
  const pct = maxCount > 0 && phase.count > 0 ? Math.max(4, Math.round((phase.count / maxCount) * 100)) : 0;

  return (
    <>
      <span className="truncate text-[11px] font-medium text-app-text-muted sm:text-xs" title={phase.status}>
        {phase.status}
      </span>
      <div className="h-2 min-w-0 rounded-full bg-app-surface-muted">
        <div className="h-2 rounded-full bg-blue-500" style={{ width: `${pct}%` }} />
      </div>
      <span className="text-right text-xs font-semibold text-app-text tabular-nums sm:text-sm">{phase.count}</span>
      <span className="text-right text-[9px] text-slate-400 tabular-nums sm:text-[10px]">{formatMoney(phase.angebotsvolumen)}</span>
    </>
  );
}
